import Accounts from "./Accounts";


class Simpliad extends Accounts{
    constructor(params) {
      super(params);
    this.accountLabel = "Simpliad";
    this.accountType = "Simpliad";
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }

    setPlatformId(val){
      this.platformId = val;
    }
    setName(val){
      this.name = val;
    }
}

export default Simpliad;
  